import React, { Component } from 'react';
import qs from 'querystringify';
import { i18nMark, withI18n } from 'lingui-react';

import { getTopicsByModuleIdAndCategoryAndLevel, getAssessment, getCompanyLevel } from '../../../../services/index';
import { HeaderTag } from './components/HeaderTag/index';
import { ModalConfirm } from './components/ModalConfirm/index';
import escButton from '../../../../assets/images/esc.svg';

class HeaderQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      completedAnswerOrganization: false,
      completedAnswerTechnology: false
    }
  }

  updateAnswerCompletion() {
    const assessmentId = qs.parse(this.props.location.search).assessmentId;
    getAssessment(assessmentId)
      .then(assessment => {
        getCompanyLevel(assessment.companyId)
          .then(companyLevel => {
            const questionIds = assessment.answers.map(answer => answer.questionId)
            getTopicsByModuleIdAndCategoryAndLevel(assessment.moduleId, 'organization', companyLevel)
              .then(topics => {
                const questionIdsForOrganization = topics.reduce((preVal, curVal) => {
                  preVal = [...preVal, ...curVal.questionIds]
                  return preVal
                }, [])
                let a = new Set(questionIdsForOrganization);
                let b = new Set(questionIds);
                let intersection = new Set([...a].filter(x => b.has(x)));
                if (intersection.size === questionIdsForOrganization.length)
                  this.setState({ completedAnswerOrganization: true })
              })
            getTopicsByModuleIdAndCategoryAndLevel(assessment.moduleId, 'technology', companyLevel)
              .then(topics => {
                const questionIdsForTechnology = topics.reduce((preVal, curVal) => {
                  preVal = [...preVal, ...curVal.questionIds]
                  return preVal
                }, [])
                let a = new Set(questionIdsForTechnology);
                let b = new Set(questionIds);
                let intersection = new Set([...a].filter(x => b.has(x)));
                if (intersection.size === questionIdsForTechnology.length)
                  this.setState({ completedAnswerTechnology: true })
              })
          })
      })
      .catch(error => {
        console.log('Error', error)
      })
  }

  render() {
    const category = qs.parse(this.props.location.search).category;
    const assessmentId = qs.parse(this.props.location.search).assessmentId;
    return [
      <HeaderTag
        onClick={() => {
          this.props.saveAnsweredQuestions();
          this.props.history.push('question?assessmentId=' + assessmentId + '&category=organization');
        }}
        key={1}
        header="organization"
        tagContent={this.props.i18n._(i18nMark('Category: Organization'))}
        active={category === 'organization'}
        completed={this.state.completedAnswerOrganization}
      />,
      <HeaderTag
        onClick={() => {
          this.props.saveAnsweredQuestions();
          this.props.history.push('question?assessmentId=' + assessmentId + '&category=technology');
        }}
        key={2}
        header="technology"
        tagContent={this.props.i18n._(i18nMark('Category: Technology'))}
        active={category === 'technology'}
        completed={this.state.completedAnswerTechnology}
      />,
      <div key={3} onClick={this.props.showConfirm} className="esc-button">
        <img src={escButton} alt="" />
      </div>,
      <ModalConfirm key={4} modal={this.props.isShowConfirm} accept={this.props.navigateToDashboard} toggle={this.props.showConfirm} />
    ];
  }
}
export default withI18n()(HeaderQuestion)



// WEBPACK FOOTER //
// ./src/components/Header/components/HeaderQuestion/HeaderQuestion.js